<template>
  <div>
    <div
      v-if="loading"
      class="d-flex"
    >
      <v-col cols="12">
        <v-sheet
          v-if="loading"
          :color="'grey lighten-4'"
          class="pa-3"
        >
          <v-skeleton-loader type="card-heading, table-row-divider">
          </v-skeleton-loader>
        </v-sheet>
      </v-col>
    </div>

    <div
      v-if="!loading && !!requestDetails"
      class="d-flex header-card"
    >
      <div class="col-2">
        <v-card
          elevation="3"
          class="fill-height"
          color="var(--app-light-secondary-color)"
        >
          <div class="info-item-details text-center overflow-hidden">
            <div class="info-item-details-header">
              {{ local.caseRelatedRequest.reconsiderationFromNonCaseParty.tableHeader.requestCode }}
            </div>
            <div
              class="info-item-details-value text-h5 mt-3"
              :title="requestDetails.requestCode"
            >
              {{ requestDetails.requestCode }}
            </div>
          </div>
        </v-card>
      </div>
      <div class="col-10">
        <v-card elevation="3">
          <div class="info-item-box pa-0 ma-0">
            <div
              v-for="(header, index) in headers"
              :key="header.value"
              class="info-item-details"
              :class="index == 0 ? ' info-item-box-b' : ''"
            >
              <div class="info-item-details-header">
                {{ header.text }}
              </div>
              <div class="font-info mt-3">
                {{
                  header.formatter
                    ? header.formatter(requestDetails[header.value])
                    : header.value === 'case.caseCode'
                      ? requestDetails.case.caseCode
                      : requestDetails[header.value]
                }}
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>

    <div
      v-if="requestDetails && !loading"
      class="d-flex header-card"
    >
      <div class="col-2">
        <v-card
          elevation="2"
          outlined
          class="fill-height"
        >
          <v-tabs
            v-model="tab"
            vertical
            hide-slider
          >
            <template v-for="tabButton in caseFileTabs">
              <v-tab
                :key="tabButton.href"
                :disabled="tabButton.isDisabled"
                :href="tabButton.href"
                class="tab-button"
                active-class="tab-active"
              >
                <v-icon
                  left
                  class="tab-button-icon"
                >
                  {{ tabButton.icon }}
                </v-icon>
                <span class="mr-1"> {{ tabButton.title }}</span>
              </v-tab>
            </template>
          </v-tabs>
        </v-card>
      </div>
      <div class="col-10">
        <v-tabs-items v-model="tab">
          <v-card elevation="2">
            <v-tab-item value="tab-1">
              <v-sheet
                v-if="loading"
                :color="'grey lighten-4'"
                class="pa-3"
              >
                <v-skeleton-loader type="heading, list-item-two-line ,heading , list-item-two-line,heading , list-item-two-line">
                </v-skeleton-loader>
              </v-sheet>
              <request-details-tab
                v-if="!loading"
                :request-details="requestDetails"
                :loading="loading"
              ></request-details-tab>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <case-sessions-tab
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                :court-id="requestDetails.case.courtId"
                :request-object-key="requestObjectKey"
              ></case-sessions-tab>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <case-judgments-tab
                :case-object-key="caseObjectKey"
                :request-object-key="requestObjectKey"
                :is-pega="isPega"
                :is-secret-judgements="false"
              ></case-judgments-tab>
            </v-tab-item>

            <v-tab-item value="tab-4">
              <v-card
                flat
                class="tab-details"
              >
                <case-requests-tab
                  :case-object-key="caseObjectKey"
                  :request-object-key="requestObjectKey"
                  :is-pega="isPega"
                ></case-requests-tab>
              </v-card>
            </v-tab-item>
          </v-card>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CaseSessionsTab from './tabs/case-sessions-tab.vue';
import CaseJudgmentsTab from './tabs/case-judgments-tab.vue';
import CaseRequestsTab from './tabs/case-requests-tab.vue';
import { toHijriDate } from '@/helpers/utils';
import RequestDetailsTab from './tabs/request-details-tab.vue';

const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  components: {
    CaseSessionsTab,
    CaseJudgmentsTab,
    CaseRequestsTab,

    RequestDetailsTab,
  },
  data() {
    return {
      caseDetails: {},
      requestDetails: { case: {} },
      tab: null,
      headers: [
        {
          value: 'requestStatusName',
          text: this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.tableHeader.requestStatusName,
        },
        {
          value: 'case.caseCode',
          text: this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.tableHeader.caseCode,
        },
        {
          value: 'requestType',
          text: this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.tableHeader.requestType,
          formatter: this.requestTypeName,
        },
        {
          value: 'requestDate',
          text: this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.tableHeader.requestDate,
          formatter: toHijriDate,
        },
      ],
      loading: false,
      formModel: {},
    };
  },
  computed: {
    caseObjectKey() {
      return this.requestDetails.case.objectKey;
    },
    requestObjectKey() {
      return this.$route.params.requestObjectKey;
    },
    isPega() {
      return this.$route.query.isPega;
    },
    caseFileTabs() {
      const tabs = [
        {
          href: '#tab-1',
          icon: 'mdi-file-table',
          title: this.local.bankruptcy.bankruptcyFile.basicInfo.tabTitle,
          isEnabled: true,
        },
        {
          href: '#tab-2',
          icon: 'mdi-account-group',
          title: this.local.caseFile.tabHeaders.sessions,
          isEnabled: true,
        },
        {
          href: '#tab-3',
          icon: 'mdi-gavel',
          title: this.local.caseFile.tabHeaders.judgements,
          isEnabled: true,
        },
        {
          href: '#tab-4',
          icon: 'mdi-archive',
          title: this.local.caseFile.tabHeaders.requests,
          isEnabled: true,
        },
      ];
      return tabs.filter(t => t.isEnabled);
    },
  },
  mounted() {
    this.loading = true;
    this.isRequestExists(this.requestObjectKey)
      .then((result) => {
        if (result.data) {
          this.loadData();
        } else {
          this.toaster.error(this.local.errorPages.forbidden.title);
          this.$router.push({ path: '/' });
        }
      })
      .catch(() => {
        this.toaster.error(this.local.errorPages.forbidden.title);
        this.$router.push({ path: '/' });
      });
  },
  methods: {
    toHijriDate,
    ...mapActions(['getCaseRelatedRequests', 'isRequestExists']),
    loadData() {
      this.getCaseRelatedRequests({
        requestObjectKey: this.requestObjectKey,
        isPega: this.isPega,
      })
        .then((result) => {
          this.requestDetails = result.data;
          if (this.requestDetails.stopExecution != null && this.requestDetails.stopExecution != undefined) {
            this.requestDetails.stopExecution = this.requestDetails.stopExecution ? 1 : 0;
          }
        })
        .catch((err) => {
          this.toaster.error(err.message);
        })
        .finally(() => (this.loading = false));
    },
    requestTypeName() {
      return this.local.caseRelatedRequest.reconsiderationFromNonCaseParty.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-button {
  margin: 5px;
  margin-left: 0px;
  font: normal normal normal 16px/24px Almarai;
  justify-content: right;
  letter-spacing: 0px;
  color: #8e9090 !important;
  opacity: 1;

  .tab-button-icon {
    color: #8e9090 !important;
  }

  &:hover {
    color: var(--app-primary-color) !important;
    font-weight: bold;
    background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box !important;

    .tab-button-icon {
      color: var(--app-primary-color) !important;
    }
  }
}

.tab-active {
  font-weight: bold;
  color: var(--app-lighter-primary-color) !important;
  border-left: 4px solid var(--app-lighter-primary-color);

  .tab-button-icon {
    color: var(--app-primary-color) !important;
  }
}

::v-deep .tab-details {
  box-shadow: 5px 5px 5px #00000014;
  border-radius: 22px;
  min-height: 534px;
}

.info-item-box {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
}

.info-item-details {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  color: var(--app-dark-primary-color);
  min-height: 140px;
}

.info-item-details-title {
  font-size: 14px;
}

.info-item-details-header {
  font-size: 16px;
}

.info-item-details-value {
  font-weight: bold;
  font-size: 16px;
}

::v-deep .text-c-green {
  color: var(--app-primary-color);
}

.header-card {
  background-color: rgba(228, 221, 221, 0.22);
}

.info-item-box-b {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.font-info {
  font-size: 16px;
  font-weight: 900;
}
</style>
